import type { ReactNode } from 'react';

interface StatCardProps {
  label: string;
  value: string | number;
  icon?: ReactNode;
  color?: string;
}

export function StatCard({ label, value, icon, color }: StatCardProps) {
  return (
    <div className="bg-white border border-[#DDDDDD] rounded-2xl p-5">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-medium text-[#9A9A9A] uppercase tracking-widest">{label}</p>
          <p className="text-[32px] font-bold text-[#222222] mt-1" style={color ? { color } : undefined}>
            {value}
          </p>
        </div>
        {icon && <div className="text-[#9A9A9A]">{icon}</div>}
      </div>
    </div>
  );
}
